import type { ReactNode } from 'react';

export function Notice({
  tone,
  title,
  children,
}: {
  tone: 'erreur' | 'alerte' | 'info';
  title?: string;
  children: ReactNode;
}) {
  return (
    <div className={`message message--${tone}`} role={tone === 'erreur' ? 'alert' : undefined}>
      {title !== undefined && <div className="message__titre">{title}</div>}
      <div>{children}</div>
    </div>
  );
}
